// extracted by mini-css-extract-plugin
export default {"container":"RedesSocialesPeliculas_container__hwl6f"};